
import { Component, Vue, Prop } from "vue-property-decorator";
import { GetTemDetail } from "@/request/common";
import MainHeader from "@/components/main-header.vue";
import NavLeft from "@/components/nav-left.vue";
import TemplateTransfer from "@/components/template-transfer-pc/template/template-transfer.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    TemplateTransfer,
  },
})
export default class Name extends Vue {
  private data: any = {};
  private getData() {
    if (!this.data.id) {
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetTemDetail(this, this.data.id, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
      })
      .catch(() => {
        loading.close();
      });
  }
  private mounted() {
    this.$store.commit("updateIfCompose", false);
    if (this.$route.query.id) {
      this.data.id = this.$route.query.id;
      this.getData();
    }
  }
}
